import React, {
    useState,
    forwardRef,
    useImperativeHandle,
    useEffect,
    useRef
  } from "react";
  import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
  import ImageBrowse from "../../../../Common/Image/ImageBrowse";
  import { IconPlus } from "@tabler/icons-react";
  import CommunityAdd from "./Subpeoplemenu";
  
  const Subpeople = forwardRef((props, ref) => {
    const [errors, setErrors] = useState({});
  
    const [popularImages, setPopularImages] = useState([]);
  
    const [banners, setBanners] = useState({
      banner1: { title: "", subtitle: "", description: "" }
    });
  
    const handleChange = (bannerKey, field, value) => {
      setBanners((prev) => ({
        ...prev,
        [bannerKey]: {
          ...prev[bannerKey],
          [field]: value
        }
      }));
    };
  
    useEffect(() => {
      resetData();
      if (props.data) {
        if (props.data.length > 0) {
          setSlide1ImageKey(props.data[0].imageKey);
          slide1ImageRef?.current?.setThumbnail(props.data[0].image);
          slide1ImageRef?.current?.setFileContent(props.data[0].imageFile);
        }
        if (props.data.length > 1) {
          setSlide2ImageKey(props.data[1].imageKey);
          slide2ImageRef?.current?.setThumbnail(props.data[1].image);
          slide2ImageRef?.current?.setFileContent(props.data[1].imageFile);
        }
        if (props.data.length > 2) {
          setSlide3ImageKey(props.data[2].imageKey);
          slide3ImageRef?.current?.setThumbnail(props.data[2].image);
          slide3ImageRef?.current?.setFileContent(props.data[2].imageFile);
        }
      }
    }, [props.data]);
  
    const resetData = () => {
     
    };
  
    const validate = () => {
      const errors = {};
      setErrors(errors);
      return Object.keys(errors).length === 0;
    };
  
    const getData = () => {
    
  
      let aboutData = [];
      popularImages.forEach((item) => {
        let data = item.ref?.getData();
        if (data) aboutData.push(data);
      });
  
      return {
        Heading: banners.banner1.title,
        Subheading: banners.banner1.subtitle,
        Description: banners.banner1.description,
        communitydata: aboutData
      };
    };
  
    useImperativeHandle(ref, () => ({
      getData,
      validate
    }));
  
 
    const handleAddpopImg = () => {
      setPopularImages([
        ...popularImages,
        {
          name: "people " + (popularImages.length + 1),
          image: null,
          imageFile: null,
          imageKey: "",
          show: popularImages.length === 0,
          ref: null
        }
      ]);
    };
  
    const showHidePopimgs = (index) => {
      const updated = popularImages.map((img, idx) => ({
        ...img,
        show: idx === index ? !img.show : false
      }));
      setPopularImages(updated);
    };
  
    const deletePopImgHandler = (targetIndex) => {
      const filtered = popularImages.filter((_, idx) => idx !== targetIndex);
  
      if (filtered.length === 1) {
        filtered[0]["show"] = true;
      }
  
      const deleted = popularImages[targetIndex];
      if (deleted?.imageKey) {
        props.imageDelete(deleted.imageKey);
      }
  
      setPopularImages(filtered);
    };
  
    const imageDeleteHandler = (imageKey) => {
      props.imageDelete(imageKey);
    };
  
    return (
      <>
        <div className="content d-block visible">
          <div className="content-header mb-3 d-flex justify-content-between">
            <div className="sec-titler">
              <h2 className="text-primary">people Page</h2>
              <div className="title-shape"></div>
            </div>
            <div>
              <button className="btn btn-primary" onClick={handleAddpopImg}>
                <IconPlus className="me-sm-1 me-0" size={20} />
                Add people
              </button>
            </div>
          </div>
  
          <div className="row g-3">
            <div className="col-sm-6">
              <label className="form-label">People Header</label>
              <input
                type="text"
                className="form-control"
                value={banners.banner1.title}
                onChange={(e) => handleChange("banner1", "title", e.target.value)}
                placeholder="Please enter the main title here"
              />
            </div>
            <div className="col-sm-6">
              <label className="form-label">People Sub-Heading</label>
              <input
                type="text"
                className="form-control"
                value={banners.banner1.subtitle}
                onChange={(e) => handleChange("banner1", "subtitle", e.target.value)}
                placeholder="Please enter the sub heading here"
              />
            </div>
           
          </div>
  
          <br />
  
          <div className="row g-3">
            {errors.noSlider && (
              <div style={{ color: "#ea5455", fontSize: "0.8125rem" }}>
                {errors.noSlider}
              </div>
            )}
          
           
          </div>
  
         
          <div className="accordion mt-3">
            {popularImages.map((img, idx) => (
              <CommunityAdd
                key={idx}
                data={img}
                index={idx}
                showHidePople={showHidePopimgs}
                deletePeople={deletePopImgHandler}
                imageDelete={imageDeleteHandler}
                ref={(el) => (img.ref = el)}
              />
            ))}
          </div>
        </div>
        <StepperNavigationButtons
            index={props.index}
            steps={props.steps}
            navigate={props.navigate}
            save={props.save}
          />
  
      </>
    );
  });
  
  export default Subpeople;
  